import SidebarAndPanesWithRouting from '@/components/layouts/SidebarAndPanesWithRouting.vue';
import Summary from './children/Summary.vue';
import QuickResponses from './children/QuickResponses.vue';

const rootRoute = {
  path: 'assist',
  name: 'Assist',
  component: SidebarAndPanesWithRouting,
  meta: {
    auth: true,
  },
  props: {
    baseResource: '/metrics/assist',
    singleRouterView: true,
  },
};

const commonChildMeta = {
  auth: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  {
    path: 'summary',
    name: 'Metrics.Assist.Summary',
    component: Summary,
    meta: {
      label: 'Summary',
      ...commonChildMeta,
    },
  },
  {
    path: 'quick_responses',
    name: 'Metrics.Assist.QuickResponses',
    component: QuickResponses,
    meta: {
      label: 'Quick Responses',
      ...commonChildMeta,
    },
  },
];

rootRoute.props.children = childRoutes;

export default {
  ...rootRoute,
  children: childRoutes,
};
